import { Box, List, ListItem } from '@chakra-ui/react';

import { Equipment } from '@app/api/models';
import { Txt } from '@app/components/common';

export const EquipmentsList = ({
  equips
}: {
  equips: Equipment[]
}) => {
  return <List maxH={400} overflowY='auto'>{equips.map((item) => {
    return <ListItem key={item.id} py={1} >
      <Txt textColor='brand-500'>{item.model?.name}</Txt>
      <Box display='flex' gap={2} fontSize='small' textColor='var(--chakra-colors-gray-500)'>
        <Txt fontSize='small'>{item.inventory_num}</Txt>
        <Box display='flex'>
          <Txt textColor='var(--chakra-colors-gray-700)'>SN: </Txt>
          <Txt>{item.serial_num}</Txt>
        </Box>
      </Box>
    </ListItem>;
  })}</List>;
};